import { render, staticRenderFns } from "./FeedbackList.vue?vue&type=template&id=0cf90579&scoped=true&"
import script from "./FeedbackList.vue?vue&type=script&lang=ts&"
export * from "./FeedbackList.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackList.vue?vue&type=style&index=0&id=0cf90579&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf90579",
  null
  
)

export default component.exports